import React, { useState, useEffect, Component } from 'react';
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import { useCookies } from 'react-cookie';
// import { useTable, useSortBy, usePagination } from "react-table";

function WarScoreDetails(props) {
    const [cookies] = useCookies(['user']);
	const user_id = cookies.user_id;
	const token = cookies.token;
    const { state } = props.location;
	// console.log(state);
    let filter = React.createRef();
	const [kdData] = useState(state[0]);
	const [war_id] = useState(state[1]);
	const [myper, setMyper ] = useState({width : "50%"});
	const [oppper, setOppper ] = useState({width : "50%"});
    const [myTotal, setMyTotal ] = useState(0);
	const [oppTotal, setOppTotal ] = useState(0);
    const [rows, setRows] = useState('');
    const [impactRows, setImpactRows] = useState('');
    const [currentSort, setCurrentSort] = useState(<img src={require("./../images/desc.svg").default} alt="details" className="img-fluid" onClick={() => sortByValue("asc")} />);
    const [name, setName] = useState('');
    const [all_filter, setFilter] = useState('');
    // const [pointsA, setPointsA] = useState('');
    // const [pointsB, setPointsB] = useState('');
    // const [pointsC, setPointsC] = useState('');
    // const [datas, setDatas] = useState();
	const [break_up, setbreakUp] = useState('');
	// const [a_def, setAdef] = useState('AEPS');
	// const [b_def, setBdef] = useState('DIUR*');
	// const [c_def, setCdef] = useState('Overall Sale');
	let history = useHistory();
  	useEffect(() => {
        getScoreDetails();
	}, []);

    const getScoreDetails = async () => {
		// console.log("here");
        const items = [];
        const items2 = [];
		let kId = kdData.k_id ;
		const requestOptions = {
			method: 'POST',
			headers: {'Content-Type': 'application/json','token':token,'userId':user_id},
			body: JSON.stringify({user_id:user_id,k_id:kdData.k_id,war_id:war_id }),
		};
		console.log(requestOptions);
		const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-war-distributor-data', requestOptions);
		const data = await response.json();
		if (data.status === "success"){
            let temp = [];
            Object.keys(data.all_factor).forEach(function(key) {
                let temp_val = data.all_factor[key];
                temp_val = temp_val.replaceAll("_", " ");
                temp.push(<option key={key} value={data.all_factor[key]}>{temp_val}</option>);
            });
            let f = <select ref={filter} className='filter' onChange={() => changeFilter()}>
                <option value='all'>All</option>
                {temp}
                </select>;
            setFilter(f);
            let userData = data.user_data;
            if(!(data.my_total == 0 && data.opp_total == 0)){
                setMyper({width : (data.my_total*100/(data.opp_total+data.my_total))+"%"});
                setOppper({width : 100 - (data.my_total*100/(data.opp_total+data.my_total))+"%"});
            }
            setMyTotal(data.my_total);
            setOppTotal(data.opp_total);
            localStorage.setItem("filter", 'all');
            localStorage.setItem("war_breakup", JSON.stringify(data));
            userData.sort((a,b) => b['total_points'] - a['total_points'] );
            let i = 0;
            Object.keys(userData).forEach(function(key) {
                i++;
                console.log(userData[key]['total_points']);
                if(userData[key]['impact_warrior'] == 1){
                    items2.push(
                        <div className="w-100 table-row flt-l" style={{
                            backgroundImage : `url(${require("./../../src/images/impact.png").default})`,
                            // backgroundImage : `linear-gradient(0deg, rgba(0, 0, 0, 0%), rgba(94, 74, 74, 85%)) , url(${img})`, 
                            backgroundSize: `100% 100%`}}
                                 key={key}>
                            <div className="w-15 flt-l impact-dist-rank">{i}</div>
                            <div className="w-40 flt-l">
                                <span className="impact-dist-name">{userData[key]['shop_name']}</span>
                                <br/>
                                <span className="impact-dist-mob">{userData[key]['area']} {userData[key]['city']}</span>
                            </div>
                            <div className="w-45 flt-l">
                                <div className="w-70 flt-l impact-dist-score">{userData[key]['total_points'].toLocaleString('en-In', {maximumFractionDigits:0})}</div>
                                <div className="w-30 flt-l" data-toggle="modal" data-target="#bottom_modal" onClick={() => viewBeakup(userData[key])}>
                                    <img src={require("./../images/arrow-right.svg").default} alt="details" className="img-fluid" />
                                </div>
                                <br/>
                                {/* <div className="w-70 flt-l impact-dist-score">(5 * {(userData[key]['total_points']/5).toLocaleString('en-In', {maximumFractionDigits:0})} )</div> */}
                            </div>
                        </div>
                    ); 
                } else {
                items.push(
                    <div className="w-100 table-row flt-l" key={key}>
                        <div className="w-15 flt-l dist-rank">{i}</div>
                        <div className="w-40 flt-l">
                            <span className="dist-name">{userData[key]['shop_name']}</span>
                            <br/>
                            <span className="dist-mob">{userData[key]['area']} {userData[key]['city']}</span>
                        </div>
                        <div className="w-45 flt-l">
                            <div className="w-70 flt-l dist-score">{userData[key]['total_points'].toLocaleString('en-In', {maximumFractionDigits:0})}</div>
                            <div className="w-30 flt-l" data-toggle="modal" data-target="#bottom_modal" onClick={() => viewBeakup(userData[key])}>
                                <img src={require("./../images/arrow-right.svg").default} alt="details" className="img-fluid" />
                            </div>
                        </div>
                    </div>
                );
                }
            });
            setImpactRows(items2);
            setRows(items);
			// setError(true);
		}
    }

    async function viewBeakup(data){
        let all_data = localStorage.getItem("war_breakup");
        all_data = JSON.parse(all_data);
        let all_factor = all_data.all_factor;
        let temp = [];
        console.log(all_factor);
        Object.keys(all_factor).forEach(function(key) {
            let points = 0;
            if(data[all_factor[key]+'_points' ] !== undefined){
                points = data[all_factor[key]+'_points' ];
            } else if(data[all_factor[key]] !== undefined){
                points = data[all_factor[key]];
            }
            let serviceName = all_factor[key];
            serviceName = serviceName.replaceAll("_", " ");
            // console.log(all_factor);
            // console.log(all_factor[key+'_def']);
            // temp.push(<div key={key} className="padding-all w-100 flt-l">
            //     <div className="type-range w-100">
            //         <div className="score-type-left flt-l" style={{width:'25%'}}>{all_data[all_factor[key]+'_def']}</div>
            //         <div className="score-type-right flt-l" style={{width:'75%'}}><span className='padding-right'>{points.toLocaleString('en-In', {maximumFractionDigits:0})}</span></div>
            //     </div>
            // </div>);
            let img = require("./../images/other.png").default;
            if(serviceName == "Mobile Recharge"){
                img = require("./../images/recharge.png").default;
            } else if(serviceName == "DTH Recharge"){
                img = require("./../images/dth.png").default;
            } else if(serviceName == "Utility Bill Payment"){
                img = require("./../images/Utility.png").default;
            } else if(serviceName == "AEPS"){
                img = require("./../images/aeps.png").default;
            } else if(serviceName == "DMT"){
                img = require("./../images/dmt.png").default;
            } else if(serviceName == "Flight Booking"){
                img = require("./../images/flight.png").default;
            } else if(serviceName == "Cashdrop"){
                img = require("./../images/Cash_Collection.png").default;
            } else if(serviceName == "MicroATM"){
                img = require("./../images/atm.png").default;
            } else if(serviceName == "Dhanak"){
                img = require("./../images/dhanak.png").default;
            } else if(serviceName == "Payment Gateway Credit Card"){
                img = require("./../images/Payment_Gateway.png").default;
            } else if(serviceName == "Daily Invest"){
                img = require("./../images/Daily_invest.png").default;
            }else if(serviceName === "Dhanak Refurb"){
                img = require("./../images/dhanakRefurb.png").default;
            } else if(serviceName === "Dhanak Device Hub"){
                img = require("./../images/dhanakHub.png").default;
            } else if(serviceName === "IRCTC"){
                img = require("./../images/irctc.png").default;
            } else if(serviceName === "Pancard"){
                img = require("./../images/pan_card.png").default;
            } else if(serviceName === "Bonus"){
                img = require("./../images/bonus.svg").default;
            } else if(serviceName === "Membership Rental"){
                img = require("./../images/other.png").default;
            } else {
                img = require("./../images/other.png").default;
            }
            temp.push(
				<div key={key+'_pb'} className="row row-override section-2">
					<div className="listCont-2">
						<div className="w-70 flt-l">
							<div className="w-100 pad-15"><img className="img-pad" src={img}/>{serviceName}</div>
						</div>
						<div className="w-30 flt-l">
							<div className="w-100 pad-15 t-a-r">{points.toLocaleString('en-In', {maximumFractionDigits:0})}</div>
						</div>
					</div>
				</div>
			);
        });
        setbreakUp(temp);
        setName(data.dist_name);
        // setPointsA(data.a_points);
        // setPointsB(data.b_points);
        // setPointsC(data.c_points);
    }

    async function changeFilter(sorting=''){
        // console.log(filter.current);
        let type = '';
        const items = [];
        const items2 = [];
        if(filter.current == null){
            type = localStorage.getItem("filter");
        } else {
            type = filter.current.value;
            localStorage.setItem("filter", type);
        }
        let data = localStorage.getItem("war_breakup");
        data = JSON.parse(data);
        let userData = data.user_data;
        if(sorting === ''){
            // console.log("here");
            sorting = 'desc';
            setCurrentSort(<img src={require("./../images/desc.svg").default} alt="details" className="img-fluid" onClick={() => sortByValue("asc")} />);
        }
        if(type == 'all'){
            if(sorting == 'desc'){
                userData.sort((a,b) => b['total_points'] - a['total_points'] );
            } else{
                userData.sort((a,b) => a['total_points'] - b['total_points'] );
            }
        } else if(type == 'overall'){
            if(sorting == 'desc'){
                userData.sort((a,b) => b['c_points'] - a['c_points'] );
            } else{
                userData.sort((a,b) => a['c_points'] - b['c_points'] );
            }
        } else if(type == 'pom'){
            if(sorting == 'desc'){
                userData.sort((a,b) => b['a_points'] - a['a_points'] );
            } else{
                userData.sort((a,b) => a['a_points'] - b['a_points'] );
            }
        } else if(type == 'dius'){
            if(sorting == 'desc'){
                userData.sort((a,b) => b['b_points'] - a['b_points'] );
            } else{
                userData.sort((a,b) => a['b_points'] - b['b_points'] );
            }
        } else {
            if(sorting == 'desc'){
                userData.sort((a,b) => b[type] - a[type] );
            } else{
                userData.sort((a,b) => a[type] - b[type] );
            }
        }
        // console.log(type);
        // console.log(sorting);
        let i = 0;
        if(sorting == 'desc'){
            i = 0;
        } else {
            i = userData.length + 1;
        }

        Object.keys(userData).forEach(function(key) {
            if(sorting == 'desc'){
                i++;
            } else {
                i--;
            }
            let points = 0;
            if(type == 'all'){
                points = userData[key]['total_points'];
            } else if(type == 'overall'){
                points = userData[key]['c_points'];
            } else if(type == 'pom'){
                points = userData[key]['a_points'];
            } else if(type == 'dius'){
                points = userData[key]['b_points'];
            } else{
                points = userData[key][type];
            }
            // console.log(userData[key]);
            if(userData[key]['impact_warrior'] === 1){
                items2.push(
                    <div className="w-100 table-row flt-l"  style={{
                        backgroundImage : `url(${require("./../../src/images/impact.png").default})`,
                        // backgroundImage : `linear-gradient(0deg, rgba(0, 0, 0, 0%), rgba(94, 74, 74, 85%)) , url(${img})`, 
                        backgroundSize: `100% 100%`}} key={key}>
                        <div className="w-15 flt-l impact-dist-rank">{i}</div>
                        <div className="w-40 flt-l">
                            <span className="impact-dist-name">{userData[key]['shop_name']}</span>
                            <br/>
                            <span className="impact-dist-mob">{userData[key]['area']} {userData[key]['city']}</span>
                        </div>
                        <div className="w-45 flt-l">
                            <div className="w-70 flt-l impact-dist-score">{points.toLocaleString('en-In', {maximumFractionDigits:0})}</div>
                            <div className="w-30 flt-l" data-toggle="modal" data-target="#bottom_modal" onClick={() => viewBeakup(userData[key])}>
                                <img src={require("./../images/arrow-right.svg").default} alt="details" className="img-fluid" />
                            </div>
                            <br/>
                            <div className="w-70 flt-l impact-dist-score">(5 * {(points/5).toLocaleString('en-In', {maximumFractionDigits:0})} )</div>
                        </div>
                    </div>
                );
            } else {
            items.push(
                <div className="w-100 table-row flt-l" key={key}>
                    <div className="w-15 flt-l dist-rank">{i}</div>
                    <div className="w-40 flt-l">
                        <span className="dist-name">{userData[key]['shop_name']}</span>
                        <br/>
                        <span className="dist-mob">{userData[key]['area']} {userData[key]['city']}</span>
                    </div>
                    <div className="w-45 flt-l">
                        <div className="w-70 flt-l dist-score">{points.toLocaleString('en-In', {maximumFractionDigits:0})}</div>
                        <div className="w-30 flt-l" data-toggle="modal" data-target="#bottom_modal" onClick={() => viewBeakup(userData[key])}>
                            <img src={require("./../images/arrow-right.svg").default} alt="details" className="img-fluid" />
                        </div>
                    </div>
                </div>
            );
            }
        });
        setImpactRows(items2);
        setRows(items);
        
    }

    function refreshPage() {
        window.location.reload(false);
    }
    async function sortByValue(type){
        // console.log(type);
        if(type == 'asc'){
            setCurrentSort(<img src={require("./../images/asc.svg").default} alt="details" className="img-fluid" onClick={() => sortByValue("desc")} />);
            changeFilter('asc');
        } else {
            setCurrentSort(<img src={require("./../images/desc.svg").default} alt="details" className="img-fluid" onClick={() => sortByValue("asc")} />);
            changeFilter('desc');
        }
    }

    return (
<>
	<Helmet link={
		[{"rel": "stylesheet", "href": '/css/war-score-details.css'}]
	}/>
	<div className="row no-gutters">
		<div className="application">
            <div className="appHeader appHeader-imp bg-wsd text-light position-relative">
                <div className="left">
                    <a className="headerButton goBack" onClick={() => history.goBack()} >
                        <img src={require("./../images/back.png").default} alt="back" className="img-fluid" />
                    </a>
                </div>
                <div className="pageTitle">Battle of Regions</div>
                <div className="right">
                    <div className="headerButton">
                        <img src={require("./../images/refresh-white.svg").default} alt="history" className="img-fluid" onClick={() => getScoreDetails()} />
                    </div>
                </div>
			</div>
            <div className="section floating-score position-relative">
				<div className="row mb-3">
					<div className="profile-war-info w-100 px-3">
						<div className="profile-war-header w-100">
                            <div className="w-100 flt-l">Total Points</div>
						</div>
						<div className="profile-war-data-score w-100 flt-l">
							<div className="score-range w-100">
								<div className="score-range-left flt-l" style={myper}>&nbsp;</div>
								<div className="score-range-right flt-l" style={oppper}>&nbsp;</div>
							</div>
						</div>
						<div className="profile-war-data-bottom w-100 flt-l">
							<div className="w-50 flt-l text-alg-left">
								<div className="w-100 flt-l score-team">{kdData.my_kd_name}</div>
								<div className="w-100 flt-l team-score">{myTotal.toLocaleString('en-In', {maximumFractionDigits:0})}</div>
							</div>
							<div className="w-50 flt-l text-alg-right">
								<div className="w-100 flt-l score-team">{kdData.opp_kd_name}</div>
								<div className="w-100 flt-l team-score">{oppTotal.toLocaleString('en-In', {maximumFractionDigits:0})}</div>
							</div>
						</div>
					</div>
				</div>
            </div>
            <div className="section score-table-cont position-relative">
                <div className="w-100 score-table flt-l">
                    <div className="w-100 table-top-box flt-l">
                        <div className="w-50 flt-l dist-title">
                            Distributor Ranking
                        </div >
                        {/* <div className="w-10 flt-l">
                            <img src={require("./../images/RefreshSVG.svg").default} alt="history" className="img-fluid" onClick={() => getScoreDetails()} />
                        </div> */}
                        <div className="w-40 flt-l">
                            {all_filter}
                            {/* <select ref={filter} className='filter' onChange={() => changeFilter()}>
                                <option value='all'>All</option>
                                <option value='overall'>{c_def}</option>
                                <option value='pom'>{a_def}</option>
                                <option value='dius'>{b_def}</option>
                            </select> */}
                        </div>
                        <div className="w-10 flt-l">
                            {currentSort}
                        </div>
                    </div>
                    <div className="w-100 table-header flt-l">
                        <div className="w-15 flt-l pad-l-5">Rank</div>
                        <div className="w-40 flt-l pad-l-20">Distributor</div>
                        <div className="w-45 flt-l pad-l-20">Points</div>
                    </div>
                    <div className='sc'>
                        {impactRows}
                        {rows}
                    </div>
                    {/* <div className="w-100 table-row flt-l">
                        <div className="w-15 flt-l dist-rank">1</div>
                        <div className="w-40 flt-l"><span className="dist-name">Vijay Kumar</span><br/><span className="dist-mob">9821233441</span></div>
                        <div className="w-45 flt-l">
                            <div className="w-70 flt-l dist-score">123456781</div>
                            <div className="w-30 flt-l"></div>
                        </div>
                    </div>
                    <div className="w-100 table-row flt-l">
                        <div className="w-15 flt-l dist-rank">2</div>
                        <div className="w-40 flt-l"><span className="dist-name">Ajay Kumar</span><br/><span className="dist-mob">9821233442</span></div>
                        <div className="w-45 flt-l">
                            <div className="w-70 flt-l dist-score">123456782</div>
                            <div className="w-30 flt-l"></div>
                        </div>
                    </div>
                    <div className="w-100 table-row flt-l">
                        <div className="w-15 flt-l dist-rank">3</div>
                        <div className="w-40 flt-l"><span className="dist-name">Sanjay Kumar</span><br/><span className="dist-mob">9821233443</span></div>
                        <div className="w-45 flt-l">
                            <div className="w-70 flt-l dist-score">123456783</div>
                            <div className="w-30 flt-l"></div>
                        </div>
                    </div> */}
                </div>
            </div>
		</div>
		<div className="bg"></div>
        <div className="modal bottom fade" id="bottom_modal" tabIndex="-1" role="dialog" aria-labelledby="bottom_modal">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header border-0 px-26 text-center d-block" style={{height: `50px`}}>
                        <h5 className="modal-title"><span>{name}</span></h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{opacity: `1`,position: `relative`,top: `-20px`}}>
                            <img src={require("./../images/close.png").default} alt="close" className="img-fluid" />
                        </button>
                    </div>
                    <div className="sub-data-2 px-34">
                        {break_up}
                    </div>
                </div>
            </div>
        </div>
	</div>
</>
    );
}

export default WarScoreDetails;
